import React from 'react';
import NumberEditor from '../../components/NumberEditor';
import { Col } from '../../components/RowCol';
import Spacer from '../../components/Spacer';

type Props = {
	wagers: [number, number] | null;
	setWagers: (wagers: [number, number]) => void;
}

type State = {
	A: number | null;
	B: number | null;
}

class FinalJeopardyWagers extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			A: null,
			B: null,
		};
	}

	confirm = () => {
		const { setWagers } = this.props;
		const { A, B } = this.state;
		if (A !== null && B !== null) {
			setWagers([A, B]);
		}
	};

	render() {
		const { A, B } = this.state;
		return (
			<Col>
				<NumberEditor
					label="Set Team A Wager:"
					number={A ?? 0}
					edit={(A: number) => this.setState({ A })}
				/>
				<Spacer vertical={10} />
				<NumberEditor
					label="Set Team B Wager:"
					number={B ?? 0}
					edit={(B: number) => this.setState({ B })}
				/>
				{A !== null && B !== null && (
					<>
						<Spacer vertical={50} />
						<button
							onClick={this.confirm}
							style={{
								fontSize: '20px',
							}}
						>
							Double-check and confirm both wagers
						</button>
					</>
				)}
			</Col>
		);
	}
}

export default FinalJeopardyWagers;
